module.exports = __webpack_public_path__ + "media/vraag_3_antwoord.05b7ec89.mp3";